import { Flex, VStack } from "@chakra-ui/react";
import SettingsPageHeader from "components/beta/SettingsPageHeader";

import Heading, { HeadingType } from "components/Heading";
import SupportSeagullIcon from "lib/svgs/seagull/SupportSeagull";
import SupportForm from "./SupportForm";

export default function SupportContainer(): JSX.Element {
  return (
    <Flex flexDirection="column">
      <SettingsPageHeader header="Customer Support" noMargin />
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        marginTop={["20px", "20px", "20px", "30px", "40px"]}
      >
        <VStack spacing="24px">
          <SupportSeagullIcon />
          <Heading type={HeadingType.HEADING_MED}>We got your back</Heading>
          <Heading
            type={HeadingType.HEADING_MED_LIGHT}
            color="textAndShapes.Input"
          >
            Contact us with any questions, issues, or suggestions!
          </Heading>
        </VStack>
        <SupportForm />
      </Flex>
    </Flex>
  );
}
